export const VISUAL_GROUP_TYPE = "visual-group";
export function isVisualGroup(what) {
    return what.type.includes(VISUAL_GROUP_TYPE);
}
//# sourceMappingURL=visual-group.js.map